import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../BASEURL";

export default function GallaryAdd() {
  const [gallary_name, setName] = useState("");
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      // Check file type
      const allowedTypes = ['image/jpeg', 'image/png', 'image/gif', 'application/pdf'];
      if (!allowedTypes.includes(selectedFile.type)) {
        setError("Please select a valid image (JPEG, PNG, GIF) or PDF file.");
        return;
      }
      setFile(selectedFile);
      setError(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!gallary_name) {
      setError("Please provide gallary name.");
      return;
    }

    setLoading(true);
    setError(null);

    const formData = new FormData();
    formData.append('gallary_name', gallary_name);
    if (file) {
      formData.append('gallary_photo', file);
    }

    try {
      const response = await fetch(`${BASE_URL}/api/galleries`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to add gallary: ${response.status} ${errorText}`);
      }

      navigate("/admin/GallaryList");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6">

      {/* PAGE TITLE */}
      <h1 className="text-2xl font-brand font-bold text-brandBlue mb-6">
        Add New Gallary
      </h1>

      {/* FORM CARD */}
      <div className="bg-white p-6 shadow-md rounded-xl border border-brandLight">

        {/* ERROR MESSAGE */}
        {error && (
          <div className="bg-red-100 text-red-700 p-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-6">

          {/* GALLARY NAME */}
          <div className="flex flex-col">
            <label className="font-medium text-brandGrey mb-1">
              Gallary Name
            </label>
            <input
              type="text"
              value={gallary_name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter gallary name"
              className="border border-brandLight rounded-lg px-4 py-2 focus:outline-brandBlue"
              required
            />
          </div>

          {/* GALLARY PHOTO */}
          <div className="flex flex-col md:col-span-2">
            <label className="font-medium text-brandGrey mb-1">
              Gallary Photo ( Image )
            </label>
            <input
              type="file"
              accept="image/*,.pdf"
              onChange={handleFileChange}
              className="border border-brandLight rounded-lg px-4 py-2 focus:outline-brandBlue"
            />
            {file && <p className="text-sm text-gray-600 mt-1">Selected: {file.name}</p>}
          </div>

        </form>

        {/* SUBMIT BUTTON */}
        <div className="mt-6">
          <button
            onClick={handleSubmit}
            disabled={loading}
            className="bg-brandBlue hover:bg-brandOrange border-gold text-gold border px-6 py-3 rounded-lg font-medium transition disabled:opacity-50"
          >
            {loading ? "Adding..." : "Add Gallary"}
          </button>
        </div>

      </div>
    </div>
  );
}